import React from 'react';
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import Swal from 'sweetalert2'
import axios from 'axios';
import { API_MOSA_URL, ACCESS_TOKEN_NAME } from '../constants/apiContants';
import LoadingOverlay from 'react-loading-overlay';
import i18n from '../i18n';
import PropTypes from 'prop-types'
import store from "../store/index";

class Login extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            count: 0,
            page: 0,
            email: '',
            name: '',
            mobile: '',
            password: '',
            isActive: false,
            confirmpassword: '',
            sessionid: '',
            password: '',
            otp: '',
            lang: localStorage.getItem('lang'),
            confirmpassword: '',
            errors: {}
        };
        this.backPressed = this.backPressed.bind(this)
        this.sendDetailsToServer = this.sendDetailsToServer.bind(this)
        this.sendOTP = this.sendOTP.bind(this)

        this.redirectToValidate = this.redirectToValidate.bind(this)

    }

    backPressed() {
        this.props.history.push('/');
    }
    mySubmitHandler = (event) => {
        let errors = {};

        event.preventDefault();
        //this.props.history.push('/validate');
        if (this.state.page == 0) {
            if (!this.state.name) {
                ///formIsValid = false;
                Swal.fire({
                    title: 'Error!',
                    text: "Name Cannot be empty",
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })
                errors["email"] = "Email Cannot be empty";
            } else if (!this.state.mobile) {
                Swal.fire({
                    title: 'Error!',
                    text: "Mobile Cannot be empty",
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })
                errors["mobile"] = "Mobile Cannot be empty";
            } else if (!this.state.email) {
                ///formIsValid = false;
                Swal.fire({
                    title: 'Error!',
                    text: "Email Cannot be empty",
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })
                errors["email"] = "Email Cannot be empty";
            }
            else {
                console.log("You are submitting " + JSON.stringify(this.state));
                //this.redirectToValidate();
                this.sendDetailsToServer(this.state);
            }
        } else if (this.state.page == 1) {
            if (!this.state.otp) {
                ///formIsValid = false;
                Swal.fire({
                    title: 'Error!',
                    text: "OTP Cannot be empty",
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })
                errors["otp"] = "OTP Cannot be empty";
            }
            else {
                console.log("You are submitting " + JSON.stringify(this.state));
                //this.redirectToValidate();
                this.sendOTP(this.state);
            }
        } else if (this.state.page == 2) {
            if (!this.state.password) {
                ///formIsValid = false;
                Swal.fire({
                    title: 'Error!',
                    text: "Password Cannot be empty",
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })
                errors["password"] = "Password Cannot be empty";
            }
            else if (!this.state.confirmpassword) {
                Swal.fire({
                    title: 'Error!',
                    text: "Password Cannot be empty",
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })
                errors["confirmpassword"] = "Password Cannot be empty";
            }
            else if (this.state.password !== this.state.confirmpassword) {
                Swal.fire({
                    title: 'Error!',
                    text: "Please enter matcching password!",
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })
            }
            else {
                console.log("You are submitting " + JSON.stringify(this.state));
                //this.redirectToValidate();
                this.setPassword(this.state);
            }
        }


        this.setState({ errors: errors });

    }
    myChangeHandler = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }


    sendDetailsToServer = (data) => {
        this.setState({ isActive: true });

        const devicedetails = {
            "imei": "862188038288320",
            "deviceOSVersion": "6.0.1",
            "uuid": "862188038288320",
            "deviceModel": "NOKIA 100",
            "deviceManufacturer": "Xiaomi",
            "serviceProvider": "airtel",
            "deviceOS": "ANDROID",
            "ipAddress": "192.168.43.210"
        }
        const headers = {
            "RequestMode": "0",
            "UserID": "3",
            "BearerKey": "Mobile",
            "ServiceId": "SERV!",
            "SessionId": "1236545",
            "Locale": "E/A",
            "DeviceDet": devicedetails

        }
        // const payload = {
        //     "username": this.state.username,
        //     "password": this.state.password,
        //     ReqHead: headers
        // }
        const payload = {
            "mobileno": data.mobile,
            "email": data.email,
            "name": data.name,
            ReqHead: headers
        }
        //localStorage.setItem(ACCESS_TOKEN_NAME,'response.data.token');
        let self = this; //  declared var 

        // redirectToHome();
        const mosa = { "mast": payload }
        console.log('calling api ...' + JSON.stringify(payload));
        axios.post(API_MOSA_URL + '/User/Register', payload)
            .then(function (response) {
                console.log(JSON.stringify(response));
                self.setState({ isActive: false });


                if (response.status === 200) {
                    //this.props.history.push('/validate');
                    if (response.data[0].StatusCode == "0") {
                        //self.redirectToValidate();
                        self.setState({ page: 1 });
                        self.setState({ sessionid: response.data[1].session_id });
                    }
                    else {
                        Swal.fire({
                            title: 'Error!',
                            text: response.data[0].Message,
                            icon: 'error',
                            confirmButtonText: 'Ok'
                        })
                    }

                } else {
                    //  props.showError("Some error ocurred");
                }
            })
            .catch(function (error) {
                console.log(error);
            });


    }
    sendOTP = (data) => {
        this.setState({ isActive: true });

        const devicedetails = {
            "imei": "862188038288320",
            "deviceOSVersion": "6.0.1",
            "uuid": "862188038288320",
            "deviceModel": "NOKIA 100",
            "deviceManufacturer": "Xiaomi",
            "serviceProvider": "airtel",
            "deviceOS": "ANDROID",
            "ipAddress": "192.168.43.210"
        }
        const headers = {
            "RequestMode": "0",
            "UserID": "3",
            "BearerKey": "Mobile",
            "ServiceId": "SERV!",
            "SessionId": "1236545",
            "Locale": "E/A",
            "DeviceDet": devicedetails

        }
        // const payload = {
        //     "username": this.state.username,
        //     "password": this.state.password,
        //     ReqHead: headers
        // }
        const payload = {
            "session_id": data.sessionid,
            "otp": data.otp,
            ReqHead: headers
        }
        //localStorage.setItem(ACCESS_TOKEN_NAME,'response.data.token');
        let self = this; //  declared var 

        // redirectToHome();
        const mosa = { "mast": payload }
        console.log('calling api ...' + JSON.stringify(payload));
        axios.post(API_MOSA_URL + '/User/ConfirmOTPRegistation', payload)
            .then(function (response) {
                console.log(JSON.stringify(response));
                self.setState({ isActive: false });


                if (response.status === 200) {
                    //this.props.history.push('/validate');
                    if (response.data[0].StatusCode == "0") {
                        //self.redirectToValidate();
                        self.setState({ page: 2 });
                        self.setState({ sessionid: response.data[1].session_id });
                    }
                    else {
                        Swal.fire({
                            title: 'Error!',
                            text: response.data[0].Message,
                            icon: 'error',
                            confirmButtonText: 'Ok'
                        })
                    }

                } else {
                    //  props.showError("Some error ocurred");
                }
            })
            .catch(function (error) {
                console.log(error);
            });


    }
    setPassword = (data) => {
        this.setState({ isActive: true });

        const devicedetails = {
            "imei": "862188038288320",
            "deviceOSVersion": "6.0.1",
            "uuid": "862188038288320",
            "deviceModel": "NOKIA 100",
            "deviceManufacturer": "Xiaomi",
            "serviceProvider": "airtel",
            "deviceOS": "ANDROID",
            "ipAddress": "192.168.43.210"
        }
        const headers = {
            "RequestMode": "0",
            "UserID": "3",
            "BearerKey": "Mobile",
            "ServiceId": "SERV!",
            "SessionId": "1236545",
            "Locale": "E/A",
            "DeviceDet": devicedetails

        }
        // const payload = {
        //     "username": this.state.username,
        //     "password": this.state.password,
        //     ReqHead: headers
        // }
        const payload = {
            "session_id": data.sessionid,
            "password": data.password,
            ReqHead: headers
        }
        //localStorage.setItem(ACCESS_TOKEN_NAME,'response.data.token');
        let self = this; //  declared var 

        // redirectToHome();
        const mosa = { "mast": payload }
        console.log('calling api ...' + JSON.stringify(payload));
        axios.post(API_MOSA_URL + '/User/ActivateAccount', payload)
            .then(function (response) {
                console.log(JSON.stringify(response));
                self.setState({ isActive: false });


                if (response.status === 200) {
                    //this.props.history.push('/validate');
                    if (response.data[0].StatusCode == "0") {
                        Swal.fire({
                            title: 'Success!',
                            allowOutsideClick: false,
                            text: response.data[0].Message,
                            icon: 'esuccessrror',
                            confirmButtonText: 'Ok'
                        }).then((result) => {
                            if (result.value) {
                                self.redirectToWelcome();
                            }
                        })
                    }
                    else {
                        Swal.fire({
                            title: 'Error!',
                            text: response.data[0].Message,
                            icon: 'error',
                            confirmButtonText: 'Ok'
                        })
                    }

                } else {
                    //  props.showError("Some error ocurred");
                }
            })
            .catch(function (error) {
                console.log(error);
            });


    }
    redirectToWelcome = () => {
        this.props.history.push('/newlogin');
        //   props.updateTitle('Register');
    }
    redirectToValidate = () => {
        this.props.history.push('/validate');
        //   props.updateTitle('Register');
    }
    componentDidMount() {
        window.scrollTo(0, 0);
        console.log('setting lang ' + store.getState().lang);
        this.setState({ lang: store.getState().lang });

    }
    render() {


        let self = this;
        store.subscribe(() => {
            console.log('change!!' + store.getState().lang);
            localStorage.setItem('lang', store.getState().lang)

            self.setState({ lang: localStorage.getItem('lang') });
        });

        // localStorage.clear();
        return (
            <LoadingOverlay
                active={this.state.isActive}
                spinner
                text='Loading ...'
            >
                <div style={{ backgroundColor: '#dfe6e9' }}>

                    <Navbar />

                    <div className="all-title-box">
                        <div className="container text-center">
                            <h1  style={{ fontFamily: 'Tajawal' }}> {i18n.t('JK96', this.state.lang)}<span className="m_1"> {i18n.t('JK8', this.state.lang)}</span></h1>
                        </div>
                    </div>
                    <section className="testimonial py-3" id="testimonial">
                        <div className="container">
                            <div className="row " style={{backgroundColor:'white'}}>
                                <div className="col-md-4 py-5  text-white text-center " style={{ backgroundColor: '#4c5a7d ' }}>
                                    <div className=" ">
                                        <div className="card-body">
                                            <img src="http://www.ansonika.com/mavia/img/registration_bg.svg" style={{ width: '30%' }} />
                                            <h2 className="py-3"  style={{ fontFamily: 'Tajawal' }}>{i18n.t('IR1', this.state.lang)}</h2>
                                            <p  style={{ fontFamily: 'Tajawal' }}>{i18n.t('IR2', this.state.lang)}
                                            </p>
                                            <br />
                                            <h2 className="py-3"  style={{ fontFamily: 'Tajawal' }}>{i18n.t('CR1', this.state.lang)}</h2>

                                            <p>        <label  style={{ fontFamily: 'Tajawal' }}>{i18n.t('AR1', this.state.lang)}</label>

                                            </p>
                                            <a className="btn btn-primary" href="/companyregister" ><span style={{ color: 'lightgrey',fontFamily: 'Tajawal' }}>{i18n.t('CR2', this.state.lang)}</span></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-8 py-5 border">
                                    <div className="card-body" style={{ minHeight: '300px' }}>
                                        {this.state.page == 0 &&
                                            <div className="container">
                                                <div className="text-left">
                                                    <h3  style={{ fontFamily: 'Tajawal' }}> {i18n.t('JK103', this.state.lang)}</h3>
                                                </div>
                                                <hr />

                                                <div className="form-group row">
                                                    <div className="col text-left">
                                                        <label  style={{ fontFamily: 'Tajawal' }}> {i18n.t('JK158', this.state.lang)}</label>
                                                        <input type="text"
                                                            id="user_name"
                                                            value={this.state.name}
                                                            onChange={this.myChangeHandler}
                                                            placeholder= {i18n.t('JK158', this.state.lang)}
                                                            className="form-control" name="name" />
                                                        <span className="form-text text-muted"> {i18n.t('JK202', this.state.lang)}</span>
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <div className="col text-left">
                                                        <label  style={{ fontFamily: 'Tajawal' }}> {i18n.t('JK157', this.state.lang)}</label>
                                                        <input type="text"
                                                            name="mobile"
                                                            className="form-control"
                                                            value={this.state.mobile}
                                                            id="mobile_number"
                                                            onChange={this.myChangeHandler}
                                                            placeholder= {i18n.t('JK157', this.state.lang)} />
                                                        <span className="form-text text-muted"> {i18n.t('JK203', this.state.lang)}</span>
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <div className="col text-left">
                                                        <label  style={{ fontFamily: 'Tajawal' }}> {i18n.t('JK31', this.state.lang)}</label>
                                                        <input type="text"
                                                            id="email_address"
                                                            value={this.state.email}
                                                            onChange={this.myChangeHandler}
                                                            placeholder= {i18n.t('JK31', this.state.lang)}
                                                            className="form-control" name="email" />
                                                        <span className="form-text text-muted"> {i18n.t('JK204', this.state.lang)}</span>
                                                    </div>
                                                </div>

                                            </div>
                                        }
                                        {this.state.page == 1 &&
                                            <div className="container">
                                                <div className="text-left">
                                                    <h3  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK210', this.state.lang)}</h3>
                                                </div>
                                                <hr />

                                                <div className="form-group">
                                                    <div className="col text-left">
                                                        <label  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK211', this.state.lang)}</label>
                                                        <input type="text"
                                                            id="email_address"
                                                            onChange={this.myChangeHandler}
                                                            placeholder={i18n.t('JK212', this.state.lang)}
                                                            className="form-control"
                                                            name="otp" />
                                                        <span style={{ color: "red" }}>{this.state.errors["otp"]}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {this.state.page == 2 &&
                                            <div className="container">
                                                <div className="text-left">
                                                    <h3  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK213', this.state.lang)}</h3>
                                                </div>
                                                <hr />
                                                <div className="form-group">
                                                    <div className="col text-left">
                                                        <label  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK214', this.state.lang)}</label>

                                                        <input type="password"
                                                            id="email_address"
                                                            onChange={this.myChangeHandler}
                                                            placeholder={i18n.t('JK12', this.state.lang)}
                                                            className="form-control"
                                                            name="password" />
                                                        <span style={{ color: "red" }}>{this.state.errors["password"]}</span>
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="col text-left">
                                                        <input type="password"
                                                            id="email_address"
                                                            onChange={this.myChangeHandler}
                                                            placeholder={i18n.t('JK107', this.state.lang)}
                                                            className="form-control"
                                                            name="confirmpassword" />
                                                        <span style={{ color: "red" }}>{this.state.errors["confirmpassword"]}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                    </div>
                                    <div className="card-footer">
                                        {this.state.page == 0 &&
                                            <div className="row">
                                                <div className="col-lg-6  text-lg-center">


                                                </div>
                                                <div className="col  text-lg-center" style={{}}>
                                                    <button className="btn btn-light btn-radius btn-brd grd1" style={{}} onClick={e => this.mySubmitHandler(e)}>
                                                    {i18n.t('JK19', this.state.lang)}
                                        </button>
                                                </div>
                                            </div>
                                        }
                                        {this.state.page == 1 &&
                                            <div className="row">
                                                <div className="col-lg-4  text-lg-center" >

                                                    <button type="reset" className="btn btn-light btn-radius btn-brd grd1" style={{ margin: '5px', }} onClick={e => this.setState({ page: 0 })}> {i18n.t('JK18', this.state.lang)}</button>

                                                </div>
                                                <div className="col-lg-4  text-center"  >

                                                    <button type="reset" className="btn btn-light btn-radius btn-brd grd1" style={{ margin: '5px', textAlign: 'center' }} > {i18n.t('JK205', this.state.lang)}</button>

                                                </div>
                                                <div className="col-lg-4 text-lg-center" >
                                                    <button type="reset" className="btn btn-light btn-radius btn-brd grd1" style={{ margin: '5px', }} onClick={e => this.mySubmitHandler(e)}> {i18n.t('JK19', this.state.lang)}</button>
                                                </div>
                                            </div>
                                        }
                                        {this.state.page == 2 &&
                                            <div className="row">
                                                <div className="col-lg-6 text-lg-center"  >

                                                    <button type="reset" className="btn btn-light btn-radius btn-brd grd1" style={{ margin: '5px', minWidth: '70%' }} onClick={e => this.setState({ page: 1 })}> {i18n.t('JK18', this.state.lang)}</button>

                                                </div>
                                                <div className="col-lg-6 text-lg-center"   >
                                                    <button type="reset" className="btn btn-light btn-radius btn-brd grd1" style={{ margin: '5px', minWidth: '70%' }} onClick={e => this.mySubmitHandler(e)}> {i18n.t('JK19', this.state.lang)}</button>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <Footer />
                    </div>
            </LoadingOverlay>)
    }
}

export default Login; 